export default __webpack_public_path__ + "static/media/home.aab13bab.svg";